import { SurveyName } from '~/lib/constants/survey/SurveyName';

export const SurveyNameToDisplayNameMap: Record<SurveyName, string> = {
  [SurveyName.ADMISSIONS_INTAKE]: 'Intake Survey',
  [SurveyName.ADMISSIONS_NPS]: 'Admissions NPS',
  [SurveyName.AIMS]: 'AIMS',
  [SurveyName.ARFID]: 'Weekly ED Symptom Tracker (ARFID)',
  [SurveyName.AUDIT]: 'AUDIT',
  [SurveyName.BAS]: 'BAS',
  [SurveyName.C_SSRS_LIFETIME]: 'C-SSRS - Lifetime/Recent',
  [SurveyName.C_SSRS_LR_SCREENER]: 'C-SSRS - L/R Screen',
  [SurveyName.C_SSRS_RECENT_SCREENER]: 'C-SSRS - Recent Screen',
  [SurveyName.C_SSRS_SINCE_LAST_CONTACT]: 'C-SSRS - Since Last Contact',
  [SurveyName.C_SSRS_SLC_SCREENER]: 'C-SSRS - SLC Screen',
  [SurveyName.CET]: 'Compulsive Exercise Test (CET)',
  [SurveyName.DISCHARGE_SUMMARY]: 'Discharge Summary',
  [SurveyName.DUDIT]: 'DUDIT',
  [SurveyName.EARLY_RESPONSE_CHECK_IN]: 'Early Response Check-in',
  [SurveyName.EDE_Q]: 'Eating Disorder Severity',
  [SurveyName.FNS]: 'FNS',
  [SurveyName.GAD7]: 'GAD-7',
  [SurveyName.LETHAL_MEANS]: 'Lethal Means',
  [SurveyName.MENTOR_MATCHING]: 'Mentor Matching',
  [SurveyName.MP_INTAKE_ASSESSMENT]: 'Medical Provider Intake',
  [SurveyName.NIAS]: 'NIAS',
  [SurveyName.NIAAA_BSTAD]: 'NIAAA/BSTAD',
  [SurveyName.NON_ARFID]: 'Weekly ED Symptom Tracker',
  [SurveyName.NPS]: 'NPS',
  [SurveyName.PARDI_ARQ_PARENT]: 'ARFID Severity: Parent',
  [SurveyName.PARDI_ARQ_SELF]: 'ARFID Severity',
  [SurveyName.PATIENT_EXPERIENCE]: 'Patient Experience',
  [SurveyName.PHQ8]: 'PHQ-8',
  [SurveyName.PHQ9]: 'PHQ-9',
  [SurveyName.POP]: 'POP Form',
  [SurveyName.PSEA]: 'Parent Self-efficacy Assessment',
  [SurveyName.SAFETY_PLAN]: 'Safety Plan',
  [SurveyName.SAMPLE_SURVEY]: '',
  [SurveyName.QUALITY_OF_LIFE]: 'Quality of Life',
  [SurveyName.TREATMENT_UPDATE]: 'Treatment Update',
  [SurveyName.PCL5]: 'Stressful and Traumatic Experiences',
};
